$.extend({
	execScripts: function(text){
		if (!text) return text;
		if (window.execScript){
			window.execScript(text);
		} else {
			var script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.text = text;
			$(document.head).append(script);
			$(script).remove();
		}
		return text;
	},
	stripScripts: function(exec, bool) {
		var scripts = '';
		var text = exec.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, function(all, code){
			scripts += code + '\n';
			return '';
		});
		if (bool === true) $.execScripts(scripts);
		return text;
	},
	isIE: function(){
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");

		return (msie > 0);
	},
	ieVersion: function(){
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");

		if (msie > 0) {
			return (parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
		}
	}
});


// WEBPACK FOOTER //
// ./Javascript/jquery/Extend/global.js